import {NavLink} from "react-router-dom";
import moment from "moment/moment";
import React, {FC, useMemo, useState} from "react";
import {useClientData} from "../../resources/ClientContext";
import {useClientContactData} from "../../resources/ClientContactContext";
import {useMatches} from "../../telephone/hooks/useMatches";
import {PageHeader} from "../../../../lib/src/components/content/PageHeader";
import DynamicDataTable from "../../../../lib/src/components/data-table/DynamicDataTable";
import {SavedMatch} from "../../../../lib/src/api";
import {Button} from "../../../../lib/src/components/form/Button";
import {faChainBroken} from "@fortawesome/pro-regular-svg-icons";
import {DeleteSavedMatchModal} from "../../modals/DeleteSavedMatchModal";
import {useModal} from "@jane/lib/src/components/layout/ModalProvider";

export const MatchesPage: FC = () => {
  const {clients} = useClientData()
  const {clientContacts} = useClientContactData()
  const clientsMap = useMemo(() => {
    return new Map(clients.map(e => [e.id, e]))
  }, [clients])
  const clientContactsMap = useMemo(() => {
    return new Map(clientContacts.map(e => [e.id, e]))
  }, [clientContacts])

  const {rawMatches} = useMatches()
  const [deletedMatches, setDeletedMatches] = useState<SavedMatch['id'][]>([])

  const enrichedSavedMatches = useMemo(() => {
    return rawMatches.filter(match => !deletedMatches.includes(match.id)).map(m => {
      const entity = m.match_type === 'client' ? clientsMap.get(m.match_id) : clientContactsMap.get(m.match_id)
      return {
        ...m,
        name: entity?.name,
        url: m.match_type === 'client' ? `/clients/${m.match_id}` : `/clientContacts/${m.match_id}`,
        data: entity,
      }
    })
  }, [rawMatches, clientsMap, clientContactsMap, deletedMatches])

  return <div>
    <PageHeader>Gekoppeld</PageHeader>
    {/*<DataTable keyProperty={'id'} data={rawMatches.sort((a, b) => b.created_at.localeCompare(a.created_at)).slice(0, 5)} columns={[*/}
    {/*  {property: 'telephone_number', header: 'Nummer'},*/}
    {/*  {property: 'match_type', header: 'Gekoppeld aan', transform: (type, row) => {*/}
    {/*      if (type === 'client') {*/}
    {/*        const client = clientsMap.get(row.match_id)*/}
    {/*        return <div>*/}
    {/*          <div className={'text-xs text-slate-700'}>Cliënt {client ? `#${client.client_number}` : ''}</div>*/}
    {/*          <div className={'text-brand-primary underline'}><NavLink to={`/clients/${row.match_id}`}>{client?.name}</NavLink></div>*/}
    {/*        </div>*/}
    {/*      }*/}
    {/*    }},*/}
    {/*  {property: 'created_at', header: 'Gekoppeld', transform: (created) => moment(created).format('hh:mm DD-MM-YYYY')},*/}
    {/*]} />*/}
    <DynamicDataTable
    searchableProperties={['name', 'telephone_number']}
    placeholder={'Geen gegevens'}
    keyProperty={'id'}
    data={enrichedSavedMatches}
    availableFilters={[
      {
        title: 'Type',
        property: 'match_type',
        options: {
          'all': 'Alle',
          'client': 'Cliënt',
          'client_contact': 'Cliënt-contactpersoon',
        },
        defaultValue: 'all',
        filterCallback: (row, filter) => {
          switch(filter) {
            case "client": return row.match_type === 'client'
            case "client_contact": return row.match_type === 'client_contact'
            default: return true
          }
        },
      },
    ]}
    columns={[
      {header: 'Naam', property: 'id', transform: (id, row) => <div className={"flex items-center"}>
        <div>
          {row.match_type === 'client' ? <>
            <div className={'text-xs text-slate-700'}>Cliënt {(row.data && 'client_number' in row.data) ? `#${row.data?.client_number}` : ''}</div>
            <div className={'text-brand-primary underline'}><NavLink to={`/clients/${row.match_id}`}>{row.name ?? '?'}</NavLink></div>
          </> : <>
            <div className={'text-xs text-slate-700'}>Cliënt-contactpersoon {(row.data && 'client_number' in row.data) ? `#${row.data?.client_number}` : ''}</div>
            <div className={''}>{row.name ?? '?'}</div>
          </>}
        </div>
      </div>},
      {property: 'match_type', header: 'Type', transform: (type) => type === 'client' ? 'Cliënt' : 'Cliënt-contactpersoon'},
      {property: 'telephone_number', header: 'Telefoonnummer'},
      {header: 'Gekoppeld', property: 'created_at', transform: (created) => moment(created).format('hh:mm DD-MM-YYYY')},
      {header: 'Acties', property: 'id', transform: (id, row) => {
        return <RowActions match={row} onDeleted={(id) => setDeletedMatches(old => [...old, id])} />
          // const teamIds = teamFilterOptions.map(([id]) => id)
          // if (canLimitedListAllTeams && (row.team_id === null || !teamIds.includes(row.team_id.toString()))) {
          //   return <NavLink to={`/employees/${id}`} className={'text-brand-primary'}><HoverHint key={id} hint={'Deze medewerker zit in een team waar jij beperkte toegang tot hebt'}>
          //     <FontAwesomeIcon icon={faWarning} className={'text-brand-primary mr-1'} />
          //   </HoverHint> Beheer</NavLink>
          // }
          // if (!canListAllTeams && (row.team_id === null || !teamIds.includes(row.team_id.toString()))) {
          //   return <HoverHint key={id} hint={'Deze medewerker zit in een team waar jij geen toegang tot hebt'}>
          //     <FontAwesomeIcon icon={faTimesCircle} className={'text-gray-500 mr-1'} /> <span>Geen toegang</span>
          //   </HoverHint>
          // }
          // return <NavLink to={`/employees/${id}`} className={'text-brand-primary'}>Beheer</NavLink>

        }}
    ]}
    loading={false}
  />
  </div>
}
const RowActions: FC<{match: SavedMatch, onDeleted: (id: SavedMatch['id']) => void}> = props => {
  const {clearCachedMatch} = useMatches()
  const deleteMatchModal = useModal({title: 'Koppeling verwijderen', body: <DeleteSavedMatchModal savedMatch={props.match} reload={() => {
    props.onDeleted(props.match.id)
  }} />})
  return <Button type={'danger'} size={'sm'} icon={faChainBroken} text={'Ontkoppel'} onClick={() => deleteMatchModal.open()} />
}